import {readRememberedAccount,rememberAccount} from '@/utils/rememberedAccount'
import {assertInlineBindingScope} from '@/utils/inlineBindingScope'
import sysRequest from '@/api/sys'
import md5 from 'md5'
import { UserInfo, StateData, User,StaticData } from '@/Interfaces/user/user'
import { SelectTypes } from '@/Interfaces/user/DataItem'
import Settings from '@/Interfaces/system/setting'
import customerRequest from '@/api/customer'
import { setItem, getItem, removeItem } from '@/utils/storege'
import { TOKEN,PREVILIGES,ORGINFO, USER_INFO,CATEGORY_DATA,VIDEO_CATEGORY_DATA,SETTINGS,STYLE_DATA,SIZE_DATA,UNITS_DATA,USERINFO,PROVENCES } from '@/constants'
import store from '@/store'
import router from '@/router'
import {message} from 'ant-design-vue'

// 2026-08-24：旧等级列表保留为兼容底稿，当前有效VIP角色只覆盖对应等级的权益快照。
const mergeVipRoleBenefits=(levels:any,role:any)=>{
  const source=Array.isArray(levels)?levels:[]
  if(!role?.legacyLevelId) return source
  return source.map((level:any)=>Number(level?.id)===Number(role.legacyLevelId)?{
    ...level,
    levelName:role.roleName||level.levelName,
    count:Number(role.limitCount??level.count??0),
    clothDiscount:Number(role.clothDiscount??level.clothDiscount??100),
    fabricDiscount:Number(role.fabricDiscount??level.fabricDiscount??100),
    decorationDiscount:Number(role.decorationDiscount??level.decorationDiscount??100),
    accessoriesDiscount:Number(role.accessoriesDiscount??level.accessoriesDiscount??100),
    bokeClothDiscount:Number(role.bokeClothDiscount??level.bokeClothDiscount??100)
  }:level)
}

let authenticationAttempt=0
export default {
  namespaced: true,
  state: {
    token: getItem(TOKEN) || '',
    orgId:getItem("ORGID") || 0,
    userInfo: getItem(USER_INFO) || {},
    categoryData:getItem(CATEGORY_DATA) || [],
    styleData:getItem(STYLE_DATA) || [],
    videoCategoryData:getItem(VIDEO_CATEGORY_DATA) || [],
    sizeData:getItem(SIZE_DATA) || [],
    userData:readRememberedAccount(window.localStorage,USERINFO),
    provences:getItem(PROVENCES) || [],
    settings:getItem(SETTINGS) || [],
    previliges:getItem(PREVILIGES) || {},
    orgPreviliges:getItem(PREVILIGES) || {},
    // 2026-08-24：VIP总控的可见功能和已解锁功能分开缓存。
    vipVisibleFunctions:getItem("VIP_VISIBLE_FUNCTIONS") || {},
    vipAllowedFunctions:getItem("VIP_ALLOWED_FUNCTIONS") || {},
    orgInfo:getItem(ORGINFO) || {},
    noteId:getItem("NOTEID"),
    legacyLevels:getItem("LEGACY_LEVELS") || getItem("LEVELS") || [],
    // 2026-08-24：不从本地恢复VIP权益，必须由本次登录后的服务端有效期结果重新确认。
    vipCurrentRole:null,
    levels:mergeVipRoleBenefits(getItem("LEGACY_LEVELS") || getItem("LEVELS") || [],null),
    loginCallback:null,
    isPad:false,
  },
  mutations: {
    setNoteId(state,noteId){
      state.noteId=noteId
      setItem("NOTEID", noteId)
    },
    setIsPad(state,isPad){
      state.isPad=isPad
    },
    setLevels(state,levels){
      state.legacyLevels=Array.isArray(levels)?levels:[]
      state.levels=mergeVipRoleBenefits(state.legacyLevels,state.vipCurrentRole)
      setItem("LEGACY_LEVELS",state.legacyLevels)
      setItem("LEVELS",state.levels)
    },
    clearNoteId(state){
      state.noteId=null
      window.localStorage.removeItem("NOTEID")
    },
    setPreviliges(state:StateData,previliges:any){
      state.previliges=previliges
      setItem(PREVILIGES, previliges)
    },
    setOrgPreviliges(state:StateData,previliges:any){
      // 2026-08-24：保留机构基础功能，登录后再与客户VIP角色求有效权限交集。
      state.orgPreviliges=previliges
      state.previliges=previliges
      // 2026-08-31：切换或重新解析分店时先清除旧客户目录，禁止旧VIP可见功能越过当前分店角色上限继续显示。
      state.vipVisibleFunctions={}
      state.vipAllowedFunctions={}
      state.vipCurrentRole=null
      state.levels=mergeVipRoleBenefits(state.legacyLevels,null)
      setItem(PREVILIGES,previliges)
      setItem("VIP_VISIBLE_FUNCTIONS",{})
      setItem("VIP_ALLOWED_FUNCTIONS",{})
      setItem("LEVELS",state.levels)
    },
    setVipAccess(state:any,payload:any){
      state.vipVisibleFunctions=payload?.visible || {}
      state.vipAllowedFunctions=payload?.allowed || {}
      state.vipCurrentRole=payload?.role || null
      state.levels=mergeVipRoleBenefits(state.legacyLevels,state.vipCurrentRole)
      setItem("VIP_VISIBLE_FUNCTIONS",state.vipVisibleFunctions)
      setItem("VIP_ALLOWED_FUNCTIONS",state.vipAllowedFunctions)
      setItem("LEVELS",state.levels)
    },
    setOrgInfo(state:StateData,orgInfo:any){
      state.orgInfo=orgInfo
      setItem(ORGINFO, orgInfo)
    },
    setToken(state: StateData, token: string) {
      state.token = token
      setItem(TOKEN, token)
    },
    setUserInfo(state: StateData, userInfo: User) {
      state.userInfo = userInfo
      setItem(USER_INFO, userInfo)
    },
    setCategoryData(state: StateData, categorys: Array<StaticData>) {
      state.categoryData = categorys
      setItem(CATEGORY_DATA, categorys)
    },
    setStyleData(state: StateData, style: Array<StaticData>) {
      state.styleData = style
      setItem(STYLE_DATA, style)
    },
    setVideoCategoryData(state: StateData, style: Array<StaticData>) {
      state.styleData = style
      setItem(VIDEO_CATEGORY_DATA, style)
    },
    setSizeData(state: StateData, size: Array<StaticData>) {
      state.sizeData = size
      setItem(SIZE_DATA, size)
    },
    setUnitsData(state: StateData, units: Array<StaticData>) {
      state.unitsData = units
      setItem(UNITS_DATA, units)
    },
    setProvence(state: StateData, provences: Array<SelectTypes>) {
      state.provences = provences
      setItem(PROVENCES, provences)
    },
    setSettings(state: StateData, settings: Array<Settings>) {
      state.settings = settings
      setItem(SETTINGS, settings)
    },
    setOrgId(state:StateData,orgId){
      state.orgId=orgId
      setItem("ORGID",orgId)
    }
  },
  actions: {
    async login(context: any, userinfo: UserInfo) {
      const attempt=++authenticationAttempt
      const { username, password } = userinfo
      const res: any = await sysRequest.login({
        username,
        password: password //md5(password)
      })
      if(attempt!==authenticationAttempt)throw new Error('登录流程已变化，请重新登录')
      const data = res.data
      if(!data.avatar){
        data.avatar = require('@/assets/images/avater.png')
      }
      if (data.url) {
        data.url = process.env.VUE_APP_BASE_API + data.url.slice(1)
      }
      rememberAccount(window.localStorage,USERINFO,userinfo)
      // localStorage.removeItem(CATEGORY_DATA)
      // store.commit('setCategoryData',null)
      store.commit('user/setToken', data.token)
      store.commit('user/setUserInfo', data)
      await context.dispatch('refreshVipAccess')
      if(attempt!==authenticationAttempt)throw new Error('登录流程已变化，请重新登录')
      store.dispatch('user/getSettings')
      return data
    },
    async codeLogin(context: any, validation) {
      const attempt=++authenticationAttempt
      try{    
      // 2026-09-22：保留当前机构归属，仅转发界面明确同意协议后设置的自动注册标记。
      const res=await sysRequest.frontCodeLogin(validation.phone,validation.code,store.getters.orgId,validation.autoRegister===true,validation.wechatState || '')
        if(attempt!==authenticationAttempt)throw new Error('登录流程已变化，请重新登录')
      const data = res.data
      assertInlineBindingScope(validation.bindingContext,store.getters.token,store.getters.userInfo,store.getters.orgId,data)
        if(!data.avatar){
          data.avatar = require('@/assets/images/avater.png')
        }
        
        if (data.url) {
          data.url = process.env.VUE_APP_BASE_API + data.url.slice(1)
        }
        // 验证成功后仅记住账号；保留未迁移的历史密码。
        rememberAccount(window.localStorage,USERINFO,{username:validation.phone,remebmer:validation.remebmer===true})
        store.commit('user/setToken', data.token)
        store.commit('user/setUserInfo', data)
        await context.dispatch('refreshVipAccess')
        if(attempt!==authenticationAttempt)throw new Error('登录流程已变化，请重新登录')
        store.dispatch('user/getSettings')
        return data
      }catch(err){      
        message.error((err as any).message)
        return null
      }
    },
    
    async refreshMemberSnapshot(context:any){
      const identity=()=>JSON.stringify([context.state.orgId,context.state.userInfo?.id,context.state.token]),scope=identity()
      if(!context.state.token || !context.state.userInfo?.id)return false
      const res=await customerRequest.getSessionSnapshot()
      if(scope!==identity())return false
      const data=res.data
      if(!data || Number(data.id)!==Number(context.state.userInfo.id) || Number(data.orgId)!==Number(context.state.orgId))return false
      if(!data.avatar)data.avatar=require('@/assets/images/avater.png')
      if(data.url)data.url=process.env.VUE_APP_BASE_API+data.url.slice(1)
      context.commit('setUserInfo',{...data,token:context.state.token})
      await context.dispatch('refreshVipAccess')
      return true
    },
    async clientById(content:any,id:number){
      const identity=()=>JSON.stringify([store.state.user.token,store.state.user.userInfo?.id,store.getters.orgId]),scope=identity()
      const res = await customerRequest.clientById(id)
      if(scope!==identity())return
      const data = res.data
      store.commit('user/setUserInfo', data)      
      if(!data.avatar){
        data.avatar = require('@/assets/images/avater.png')
      }
      if (data.url) {
        data.url = process.env.VUE_APP_BASE_API + data.url.slice(1)
      } 
      store.commit('user/setToken', data.token)
      store.commit('user/setUserInfo', data)
      await content.dispatch('refreshVipAccess')
      return res
    },
    // 2026-10-18：新操作消费刷新结果；旧身份回包不覆盖切店/切号后的权限。
    async refreshVipAccess(context:any){
      const identity=()=>JSON.stringify([context.state.orgId,context.state.userInfo?.id,context.state.token])
      const startedIdentity=identity()
      if(!context.state.token || !context.state.userInfo?.id){
        context.commit('setVipAccess',{visible:{},allowed:{}})
        return false
      }
      try{
        const res=await customerRequest.getVipCatalog()
        if(startedIdentity!==identity())return false
        const types=Array.isArray(res.data?.customerTypes)?res.data.customerTypes:[]
        const type=types.find((item:any)=>Number(item.id)===Number(res.data?.currentCustomerTypeId))
        const role=type?.roles?.find((item:any)=>Number(item.id)===Number(res.data?.currentVipRoleId))
        const toMap=(items:any[]) => (Array.isArray(items)?items:[]).reduce((map:any,item:any)=>{
          if(item?.functionName) map[item.functionName]=item
          return map
        },{})
        const ordinary=res.data?.ordinaryCustomer===true && context.state.userInfo?.vipRoleId==null
        const ordinaryNames=new Set(Array.isArray(res.data?.ordinaryClientFunctionNames)?res.data.ordinaryClientFunctionNames:[])
        const ordinaryAllowed=ordinary?Object.keys(context.state.orgPreviliges || {}).filter(key=>ordinaryNames.has(key)).map(functionName=>({functionName})):[]
        const configuredVisible=ordinary?toMap(Object.entries(context.state.orgPreviliges || {}).map(([key,item]:any)=>({...item,functionName:key}))):toMap(type?.clientFunctions)
        const configuredRoleAllowed=ordinary?toMap(ordinaryAllowed):toMap(role?.clientFunctions)
        const intersectFunctions=(candidate:any,upperLimit:any)=>Object.keys(candidate || {}).reduce((result:any,key:string)=>{
          if(upperLimit?.[key]) result[key]=candidate[key]
          return result
        },{})
        // 2026-08-31：分店角色是C端功能硬上限；客户VIP只能在该上限内继续收缩，不能把分店已关闭的功能重新加回。
        const platformClient=Number(context.state.orgId)===1000
        const orgLimit={...(context.state.orgPreviliges || {})}
        const visible=platformClient?configuredVisible:intersectFunctions(configuredVisible,orgLimit)
        const allowed=platformClient?visible:intersectFunctions(configuredRoleAllowed,visible)
        const effective={...orgLimit}
        if(!platformClient){
          Object.keys(configuredVisible).forEach(key=>delete effective[key])
          Object.assign(effective,allowed)
        }
        context.commit('setPreviliges',effective)
        context.commit('setVipAccess',{visible,allowed,role})
        return ordinary || Boolean(type)
      }catch(_error){
        if(startedIdentity!==identity())return false
        if(Number(context.state.orgId)===1000){
          context.commit('setPreviliges',{...(context.state.orgPreviliges || {})})
        }
        context.commit('setVipAccess',{visible:{},allowed:{}})
        return false
      }
    },
    async getUserInfo(context: any) {
      const requestScope=JSON.stringify([store.state.user.token,store.state.user.userInfo?.id,store.state.user.userInfo?.orgId,store.getters.orgId])
      const currentScope=()=>requestScope===JSON.stringify([store.state.user.token,store.state.user.userInfo?.id,store.state.user.userInfo?.orgId,store.getters.orgId])
      const res = await sysRequest.getUserInfo()
      if(!currentScope())return
      store.commit('user/setUserInfo', res)
      return res
    },
    async getCategoryData(context:any){
      const requestScope=JSON.stringify([store.state.user.token,store.state.user.userInfo?.id,store.state.user.userInfo?.orgId,store.getters.orgId])
      const currentScope=()=>requestScope===JSON.stringify([store.state.user.token,store.state.user.userInfo?.id,store.state.user.userInfo?.orgId,store.getters.orgId])
      const res = await sysRequest.getStaticData(1)  //type1服装类别，2服装风格，3商品单位
      if(!currentScope())return
      store.commit('user/setCategoryData', res.data)

      return res.data
    },
    async getStyleData(context:any){
      const requestScope=JSON.stringify([store.state.user.token,store.state.user.userInfo?.id,store.state.user.userInfo?.orgId,store.getters.orgId])
      const currentScope=()=>requestScope===JSON.stringify([store.state.user.token,store.state.user.userInfo?.id,store.state.user.userInfo?.orgId,store.getters.orgId])
      const res = await sysRequest.getStaticData(2) //type1服装类别，2服装风格，3商品单位
      if(!currentScope())return
      store.commit('user/setStyleData', res.data)
      return res.data
    },
    async getVideoCategoryData(context:any){
      const requestScope=JSON.stringify([store.state.user.token,store.state.user.userInfo?.id,store.state.user.userInfo?.orgId,store.getters.orgId])
      const currentScope=()=>requestScope===JSON.stringify([store.state.user.token,store.state.user.userInfo?.id,store.state.user.userInfo?.orgId,store.getters.orgId])
      const res = await sysRequest.getStaticData(7) //type1服装类别，2服装风格，3商品单位,7视频分类
      if(!currentScope())return
      store.commit('user/setVideoCategoryData', res.data)
      return res.data
    },
    async getUnitData(context:any){
      const requestScope=JSON.stringify([store.state.user.token,store.state.user.userInfo?.id,store.state.user.userInfo?.orgId,store.getters.orgId])
      const currentScope=()=>requestScope===JSON.stringify([store.state.user.token,store.state.user.userInfo?.id,store.state.user.userInfo?.orgId,store.getters.orgId])
      const res = await sysRequest.getUnits() //type1服装类别，2服装风格，3商品单位
      if(!currentScope())return
      store.commit('user/setUnitsData', res.data)
      return res.data
    },
    async getSizeData(context:any){
      const requestScope=JSON.stringify([store.state.user.token,store.state.user.userInfo?.id,store.state.user.userInfo?.orgId,store.getters.orgId])
      const currentScope=()=>requestScope===JSON.stringify([store.state.user.token,store.state.user.userInfo?.id,store.state.user.userInfo?.orgId,store.getters.orgId])
      const res = await sysRequest.getSize(0) //0全部，Orgid具体机构的
      if(!currentScope())return
      store.commit('user/setSizeData', res.data)
      return res.data
    },
    async getSettings(context: any) {
      const requestScope=JSON.stringify([store.state.user.token,store.state.user.userInfo?.id,store.state.user.userInfo?.orgId,store.getters.orgId])
      const currentScope=()=>requestScope===JSON.stringify([store.state.user.token,store.state.user.userInfo?.id,store.state.user.userInfo?.orgId,store.getters.orgId])
      const res = await sysRequest.getSettings()
      if(!currentScope())return
      const url= await sysRequest.getUrlHeader()
      if(!currentScope())return
      const op:Array<Settings>=[]
      res.data.forEach(itm =>{          
        op.push(itm)
      });
      op.push({id:0,key:'imgurl',name:'OSS地址配置',desc:'',value:url.data,})
      const sett=op.reduce((calc,item)=>{
        if(!calc[item.key]){
          calc[item.key]=item
        }
        return calc
      },{})
      console.log(sett)
      store.commit('user/setSettings', sett)
      return op
    },
    async getProvence(context: any) {
      const res = await sysRequest.getProvence()
      const op:Array<any>=[]
      res.data.forEach(itm =>{          
        op.push({label:itm.cityName,value:itm.cityCode,sp:itm.inputCode})
      });
      store.commit('user/setProvence', op)
      return op
    },
    // async getProvence(context: any) {
    //   const res = await sysRequest.getCities()
    //   const op:Array<SelectTypes>=[]
    //   res.data.forEach(itm =>{          
    //     op.push(itm)
    //   });
    //   store.commit('user/setProvence', op)
    //   return op
    // },
    logout() {
      authenticationAttempt++
      store.commit('user/setToken', '')
      store.commit('user/setUserInfo', {})      
      store.commit('user/setPreviliges',store.state.user.orgPreviliges || {})
      store.commit('user/setVipAccess',{visible:{},allowed:{}})
      removeItem(TOKEN)
    }
  }
}
//npm i --save-dev @types/md5
